// §25.5 / §9.1 — Belt as an in-process app.
//
// Gated like the rest of the Arcade (D-200); Solitaire remains the one exception.
// Manifest only (D-247) — the engine, the shapes, the view and the CSS ride the lazy chunk.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export const beltApp: InProcessApp = createLazyApp({
  app: {
    id: 'belt',
    name: 'Belt',
    icon: { glyph: 'rocket', hue: 205 },
    keywords: ['asteroids', 'vector', 'space', 'shooter', 'game', 'arcade'],
    category: 'Arcade',
    // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
    group: 'Action',
    requiresAuth: true,
    // Fixed 4:3, letterboxed by the host (D-229). A wrapping field that resized would change how
    // much space a player can see, which in a game about managing momentum is not cosmetic.
    window: { width: 860, height: 700, minWidth: 560, minHeight: 460, multiWindow: false },
    jumpList: [{ id: 'new-game', label: 'New game' }],
  },
  load: () => import('./Belt'),
});
